module.exports = __webpack_public_path__ + "media/country_flags/sh-8f912055.png";